import { AgenciesWithPrimary } from "../../AgenciesWithPrimary";
import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserAgencyUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceUserSettings: DataSource;
}
